import type { AnchorableAttrs, NodeProps } from '../types';

export enum PollType {
  VOTING = 'voting',
  TRIVIA = 'trivia',
}

export enum PollStyle {
  DEFAULT = 'default',
  BULLET_POINTS = 'bullet_points',
  NUMBERED_LIST = 'numbered_list',
  UNSTYLED = 'unstyled',
  INLINE = 'inline',
}

export enum PollListStyle {
  DISC = 'disc',
  DECIMAL = 'decimal',
  NONE = 'none',
}

export type Poll = {
  poll_id?: string;
  poll_type: PollType;
  poll_style: PollStyle;
  poll_list_style: PollListStyle;
  poll_choices: PollChoiceType[];
  description: string;
  question: string;
  trivia_answer?: string;
  live_results_enabled?: boolean;
  extended_feedback_enabled?: boolean;
  redirect_url?: string;
};

export type PollChoiceType = {
  id: string;
  label: string;
  order_id: number;
  response_url: string;
};

export type TPostPollElement = {
  type: 'poll';
  attrs: AnchorableAttrs & {
    pollId?: string;
    /** @deprecated Use pollId instead */
    id?: string;
    // fetched server side runtime
    data?: Poll;
  };
};

export type TPostPollProps = NodeProps<TPostPollElement>;
